import axiox from "./pics/axiox.png";
import bbb from "./pics/bbb.jpg";
import bootstrap from "./pics/bootstrap.png";
import css from "./pics/css.jpg";
import dsa from "./pics/dsa.png";
import ejs from "./pics/ejs.jpg";
import express from "./pics/expressjs.png";
import html from "./pics/html.png";
import js from "./pics/js.png";
import jwts from "./pics/jwts.png";
import mongo from "./pics/mongo.png";
import node from "./pics/node.png";
import React from "./pics/React.png";
import Redux from "./pics/reduxpic.png";
import sql from "./pics/sql.png";
import github from "./pics/github.png";
import Postman from "./pics/postman.png";
import ReactQuery from "../myskill/pics/ReactQuery.png";
import Next from "../myskill/pics/Nextjs.png";
import Type from "../myskill/pics/ts.avif";
const data = [
  { id: 1, title: "React", Image: React },
  {
    id: 2,

    title: "Redutoolkit",
    Image: Redux,
  },
  { id: 3, title: "Bootstrap", Image: bootstrap },
  { id: 4, title: "Css", Image: css },
  {
    id: 5,

    title: "Html",
    Image: html,
  },
  { id: 6, title: "JavaScript", Image: js },
  { id: 7, title: "Node js", Image: node },
  {
    id: 8,

    title: "Express js",
    Image: express,
  },
  { id: 9, title: "MongoDb", Image: mongo },

  { id: 10, title: "Sql", Image: sql },
  {
    id: 11,

    title: "Ejs Template",
    Image: ejs,
  },
  { id: 12, title: "DSA", Image: dsa },
  {
    id: 13,

    title: "JWT",
    Image: jwts,
  },
  { id: 14, title: "Bcrypt", Image: bbb },
  { id: 15, title: "Axios", Image: axiox },
  { id: 16, title: "Postman", Image: Postman },
  { id: 17, title: "Github", Image: github },
  { id: 18, title: "TypeScript", Image: Type },
  { id: 19, title: "NextJs", Image: Next },
  { id: 20, title: "ReactQuery", Image: ReactQuery },
];

export default data;
